import { CardLinkModel } from "@models/card-link.model";
import { BaseConverter } from "./base.converter";
import { CardLinkDto } from "@dtos/card-link.dto";

export class CardLinkConverter extends BaseConverter <CardLinkModel,CardLinkDto> {


    modelToDto(model: CardLinkModel): CardLinkDto {
        return new CardLinkDto(model.title,model.distance, model.link, model.recommended, model.details, model.fullAddress);
    }

    dtoToModel(dto: CardLinkDto): CardLinkModel {
        return new CardLinkModel(dto.title,dto.distance,dto.cardLink.link, dto.cardLink.recommended, dto.details, dto.fullAddress);
    }

}